import React, { useState } from 'react';
import { Snackbar, Box, IconButton } from '@mui/material';
import RoundedBorderSubmitBtn from '../Buttons/RoundedBorderSubmitBtn';
import questionMark from '../../static/img/24questionbordered.svg';
import QuestionTooltip from '../../components2/QuestionTooltip';
import {
  BannerActionGroup,
  BannerContent,
  BannerMessageGroup,
  BannerTextContainer,
} from './style';

const CloseIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M17.25 6.75L6.75 17.25M6.75 6.75L17.25 17.25"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const TopBannerBox = ({
  bannerMessage,
  confirmButtonLabel,
  onConfirm,
  tooltip,
  onClose,
}) => {
  const [isOpen, setIsOpen] = useState(true);

  const handleClose = () => {
    setIsOpen(false);
    if (onClose) {
      onClose();
    }
  };

  return (
    <Snackbar
      open={isOpen}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      sx={{
        '& .MuiSnackbarContent-root': {
          width: { xs: '90%', sm: '400px', md: '600px' },
          minHeight: '100px',
          backgroundColor: '#000',
          color: '#fff',
          borderRadius: '8px',
          padding: '16px',
          boxShadow: '0px 4px 6px rgba(0, 255, 42, 0.2)',
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          width: '100%',
          backgroundColor: 'var(--blue-chalk)',
          color: 'var(--royal-purple)',
          padding: { xs: '16px 20px', md: '20px 40px' },
          borderRadius: '20px',
        }}
      >
        <BannerContent>
          <BannerMessageGroup>
            <BannerTextContainer>{bannerMessage}</BannerTextContainer>
            {tooltip && (
              <QuestionTooltip text={bannerMessage} img={questionMark} />
            )}
          </BannerMessageGroup>
          <BannerActionGroup>
            {confirmButtonLabel && (
              <RoundedBorderSubmitBtn
                text={confirmButtonLabel}
                onClickFn={onConfirm}
              />
            )}
            <IconButton
              size="small"
              onClick={handleClose}
              aria-label="Close"
              sx={{
                color: 'var(--light-mode-purple)',
                padding: 0,
                flexShrink: 0,
              }}
            >
              <CloseIcon />
            </IconButton>
          </BannerActionGroup>
        </BannerContent>
      </Box>
    </Snackbar>
  );
};

export default TopBannerBox;
